import { render, staticRenderFns } from "./DescriptionAddon.vue?vue&type=template&id=29ac6b2d"
import script from "./DescriptionAddon.vue?vue&type=script&lang=js"
export * from "./DescriptionAddon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports